import { setHeaderHeightVariable } from './modules/set-header-height-variable.js';
import { setViewportWidthVariable } from './modules/set-viewport-width-variable.js';
import { delayedScroll } from './modules/delayed-scroll.js';
import { disableTelOnPC } from './modules/disable-tel-on-pc.js';
import { overlay } from './modules/overlay.js';
import { tabs } from './modules/tabs.js';
import { accordion } from './modules/accordion.js';
import { contactForm7Confirmation } from './modules/contact-form-7-confirmation.js';
import { contactForm7Redirect } from './modules/contact-form-7-redirect.js';
import { headerDropdown } from './modules/header-dropdown.js';
import { drawerAccordion } from './modules/drawer-accordion.js';
import { initSwiper } from './modules/swiper-fv.js';
import { initWorksSwiper } from './modules/swiper-works.js';
import { initFeaturesSwiper } from './modules/swiper-features.js';
import { initTopicsSwiper } from './modules/swiper-topics.js';
import { initSupportSwiper } from './modules/swiper-support.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
document.addEventListener('DOMContentLoaded', () => {
  setHeaderHeightVariable();
  setViewportWidthVariable();
  delayedScroll();
  disableTelOnPC();
  overlay();
  tabs();
  accordion();
  contactForm7Confirmation();
  contactForm7Redirect();
  headerDropdown();
  drawerAccordion();
  initSwiper();
  initWorksSwiper();
  initFeaturesSwiper();
  initTopicsSwiper();
  initSupportSwiper();
});
